<template>
  <c-dialog ref="dialog" title="采购单详情" mode="slide" width="80vw" enable-flex mask-close :button="false">
    <template #head>
      <div v-if="detailData.purchase_code" class="m-detail-tag flex-center-cross">
          <label>{{detailData.purchase_code}}</label>
          <!--采购单状态-->
          <c-state tag async dict="PURCHASE_ORDER_STATE" :value="detailData.purchase_state"></c-state>
      </div>
    </template>

    <module>
      <module-col size="400">
        <c-detail class="m-detail-form">
          <c-detail-item label="采购单号">
            {{detailData.purchase_code}}
          </c-detail-item>
          <c-detail-item label="采购类型">
              <!--采购单类型-->
              <c-state tag async dict="PURCHASE_ORDER_TYPE" :value="detailData.purchase_type"></c-state>
          </c-detail-item>
          <c-detail-item label="采购数(台)">
            {{detailData.purchase_count}}
          </c-detail-item>
          <c-detail-item label="数据统计">
              <span>收 {{detailData.purchase_product_count}}</span>
              &nbsp;
              <span>验 {{detailData.checked_count}}</span>
              &nbsp;
              <span>退 {{detailData.return_count}}</span>
          </c-detail-item>
          <!--货款结算方  1：采购人，2：供应商-->
          <c-detail-item label="货款结算方">
              <span v-if="detailData.purchase_type == 2" style="color: blue">小黑回收会员</span>
              <span v-else>
                <!--采购单类型 货款结算方  1：采购人，2：供应商-->
                <span v-if="detailData.payee_user_type == 1" style="color: blue">采购人</span>
                <span v-else-if="detailData.payee_user_type == 2" style="color: green">供应商</span>
              </span>
          </c-detail-item>
          <c-detail-item label="售卖人信息"  v-if="detailData.purchase_type == 2">
              <!--售卖人信息-->
              {{detailData.seller_name}}
              {{detailData.seller_phone}}
              {{detailData.seller_address}}
          </c-detail-item>
          <c-detail-item label="快递单号"  v-if="detailData.purchase_type == 2">
              <!--售卖人信息-->
              {{detailData.express_no}}
          </c-detail-item>
          <c-detail-item label="供应商" v-if="detailData.purchase_type == 1">
            {{detailData.supplier_name||'-'}}
          </c-detail-item>
          <c-detail-item label="供应商联系人" v-if="detailData.purchase_type == 1">
            {{detailData.supplier_contact_realname||'-'}}
          </c-detail-item>
          <c-detail-item label="回收金额">
            ￥{{detailData.purchase_money}}
          </c-detail-item>
          <c-detail-item label="采购部门">
            {{detailData.purchase_dept_name||'-'}}
          </c-detail-item>
          <c-detail-item label="采购人">
            {{detailData.purchase_user_realname||'-'}}
          </c-detail-item>
          <c-detail-item label="仓管所在部门">
            {{detailData.create_dept_name||'-'}}
          </c-detail-item>
          <c-detail-item label="创建人">
            {{detailData.create_user_realname||'-'}}
          </c-detail-item>
          <c-detail-item label="创建时间">
            {{detailData.create_date||'-'}}
          </c-detail-item>
        </c-detail>
      </module-col>

      <module-col tab-type="border-tab">
        <module-tab name="采购商品" enable-flex>
          <div class="m-detail-box">
            <c-table ref="productListTable" :data="productList" border :paging="false">
              <c-table-column label="状态" width="80">
                <template #default="{data}">
                  <span v-if="detailData.purchase_type == 2">
                      <span v-if="data.state == 35" style="color: brown">待退库</span>
                      <span v-else-if="data.state == 41" style="color: red">已退库</span>
                      <span v-else-if="data.instorage_state == 2" style="color: green">已入库</span>
                      <span v-else>
                         <span v-if="data.purchase_state == 2" style="color: blue">质检中</span>
                          <span v-else-if="data.purchase_state == 3" style="color: brown">待确认</span>
                          <span v-else-if="data.purchase_state == 4" style="color: green">已确认</span>
                          <span v-else-if="data.purchase_state == 5" style="color: red">待退回</span>
                          <span v-else-if="data.purchase_state == 6" style="color: gray">已退回</span>
                      </span>
                  </span>
                  <span v-else>
                      <span v-if="data.state == 35" style="color: brown">待退库</span>
                      <span v-else-if="data.state == 41" style="color: red">已退库</span>
                      <span v-else-if="data.instorage_state == 2" style="color: green">已入库</span>
                      <span v-else>
                         <span v-if="data.inspection_state == 2" style="color: blue">已初检</span>
                         <span v-else style="color: red">待初检</span>
                      </span>
                  </span>
                </template>
              </c-table-column>
              <c-table-column label="初检状态" width="80" v-if="detailData.purchase_type == 2">
                <template #default="{data}">
                    <span v-if="data.inspection_state == 2" style="color: blue">已初检</span>
                    <span v-else style="color: red">待初检</span>
                </template>
              </c-table-column>

              <c-table-column label="分类" width="80">
                <template #default="{data}">
                  <span>{{data.category_name||'-'}}</span>
                </template>
              </c-table-column>

              <c-table-column label="品牌" width="80">
                <template #default="{data}">
                  <span>{{data.brand_name||'-'}}</span>
                </template>
              </c-table-column>

              <c-table-column label="机型" width="180">
                <template #default="{data}">
                  <span>{{data.spu_model_name||'-'}}</span>
                </template>
              </c-table-column>

              <c-table-column label="内存" width="80">
                <template #default="{data}">
                  <span>{{data.memory_name||'-'}}</span>
                </template>
              </c-table-column>

              <c-table-column label="颜色" width="120">
                <template #default="{data}">
                  <span>{{data.color_name||'-'}}</span>
                </template>
              </c-table-column>

              <c-table-column label="背贴码" width="150">
                <template #default="{data}">
                  <span>{{data.produce_unique_code||'-'}}</span>
                </template>
              </c-table-column>

              <c-table-column label="IMEI码" width="150">
                <template #default="{data}">
                  <span>{{data.produce_imei||'-'}}</span>
                </template>
              </c-table-column>

              <c-table-column label="等级" width="100">
                <template #default="{data}">
                    <c-state tag async dict="LEVEL_TYPE" :value="data.level_type"></c-state>
                </template>
              </c-table-column>

              <c-table-column label="演示机" width="80">
                <template #default="{data}">
                    <c-state dict="yesOrNoOptions" :value="data.is_demo"></c-state>
                </template>
              </c-table-column>

              <c-table-column label="外部订单号" width="120">
                <template #default="{data}">
                  <span>{{data.out_order_number||'-'}}</span>
                </template>
              </c-table-column>

              <c-table-column label="采购价" width="100">
                <template #default="{data}">
                  <span>￥{{data.purchase_price||'-'}}</span>
                </template>
              </c-table-column>

              <c-table-column label="同行价" width="100">
                <template #default="{data}">
                  <span>￥{{data.market_price||'-'}}</span>
                </template>
              </c-table-column>

              <c-table-column label="零售价" width="100">
                <template #default="{data}">
                  <span>￥{{data.retail_price||'-'}}</span>
                </template>
              </c-table-column>

              <c-table-column label="备注" width="150">
                <template #default="{data}">
                  <span>{{data.remark||'-'}}</span>
                </template>
              </c-table-column>

              <c-table-column type="button" label="操作" width="120">
                <template #default="row">
                  <c-table-button  v-if="(auth('b_offline_purchase_check')||auth('b_online_purchase_check')) && row.data.instorage_state == 1 && row.data.inspection_state == 1" icon="tf-checkout" @click="$refs.productUniqueCodeCheck.open(false,row.data);">完善初检</c-table-button>
                  <c-table-button  v-if="(auth('b_offline_purchase_check')||auth('b_online_purchase_check')) && row.data.instorage_state == 1 && row.data.inspection_state == 2" icon="tf-checkout" @click="$refs.productUniqueCodeCheck.open(false,row.data);">重新初检</c-table-button>
                  <c-table-button v-if="(auth('b_offline_purchase_check')||auth('b_online_purchase_check')) && row.data.instorage_state == 2" icon="tf-detail" @click="$refs.productUniqueCodeCheck.open(true,row.data);">详情</c-table-button>
                </template>
              </c-table-column>
            </c-table>
          </div>
        </module-tab>
      </module-col>

      <!--唯一码初检弹窗-->
      <product-unique-code-check ref="productUniqueCodeCheck" @resolve="checkResolve"></product-unique-code-check>
    </module>
  </c-dialog>
</template>

<script>
import productUniqueCodeCheck from "@/pages/product/product_unique_code_check.vue";

export default {
  name: 'purchaseDetail',

  components: {productUniqueCodeCheck},

  props: {
    id: [String, Number]
  },

  data() {
    return {
        purchase_order_id:0,
        workType: 2,
        detailData: {},
        productList:[]
    }
  },

  computed: {
  },

  methods: {
    /**
     * 加载详情
     */
    detail(){
        this.request({
          url:'/purchase/order/detail',
          data: {
            purchase_order_id: this.purchase_order_id
          },
          loading: true,
          success: data => {
            this.detailData = data.detailInfo;
            this.productList = data.productList||[];
          }
        });
    },

    /**
     * 初检完成后：刷新本详情，并通知打开本弹窗的外层列表刷新
     */
    checkResolve(){
        this.detail();
        this.$emit('resolve');
    },

    open() {
        this.purchase_order_id = this.id;
        this.detail();
        this.$refs.dialog.open();
    }
  }
}
</script>

<style lang="stylus" scoped>
.logs-list {
  padding: 10px 10px;

  li {
    padding: 4px 0;
    line-height: 16px;
    font-size: 13px;
    color: #666;
  }
}
</style>